import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {AlignmentMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/contextMenu/AlignmentMenu';
import {DistributionMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/contextMenu/DistributionMenu';
import {OrderMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/contextMenu/OrderMenu';
import {EditMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/EditMenuItems';
import {ContextMenuTarget, IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';

export abstract class SurfaceContextMenuProvider
{
    public static contextMenuProvider(target:ContextMenuTarget):IContextMenuItem[]
    {
        const {surfaceArea, surfaceSelection, topMenu} = controllers.ui;

        if( !(target instanceof HTMLElement) )
        {
            return [];
        }

        const currentLayerPage:Page = surfaceArea.getCurrentLayerPage();
        const targetBox = surfaceArea.findClosestBoxByElement(currentLayerPage, target);
        const selectedBoxes = surfaceSelection.getSelectedBoxes();

        const commonMenuItems:IContextMenuItem[] = [
            EditMenuItems.buildSurfaceCutMenuItem(),
            EditMenuItems.buildSurfaceCopyMenuItem(),
            EditMenuItems.buildSurfacePasteMenuItem(),
            {
                label: 'Delete',
                handler: surfaceArea.removeSelectedVisualComponents,
                isDisabled: !surfaceArea.isDeleteActionAvailable()
            }
        ];

        const menuItems:IContextMenuItem[] = [...commonMenuItems];

        const isRoot = !targetBox;
        const isSingleSelected = selectedBoxes.length === 1;
        const isMultipleSelected = selectedBoxes.length > 1;

        if( isRoot )
        {
            // TODO:
        }
        else if( isSingleSelected )
        {
            const orderMenuItems = OrderMenu.build(targetBox);

            menuItems.push(
                ...orderMenuItems
            );
        }
        else if( isMultipleSelected )
        {
            const orderMenuItems = OrderMenu.build(targetBox);
            const alignmentMenuItems = AlignmentMenu.build(targetBox);
            const distributionMenuItems = DistributionMenu.build(targetBox);

            menuItems.push(
                ...orderMenuItems,
                ...alignmentMenuItems,
                ...distributionMenuItems
            );
        }

        if( surfaceArea.isLockActionAvailable() || surfaceArea.isUnlockActionAvailable() ||
            surfaceArea.isLockNestedActionAvailable() || surfaceArea.isUnlockNestedActionAvailable() )
        {
            menuItems.push({
                label: '',
                isSeparator: true
            });

            if( surfaceArea.isLockActionAvailable() )
            {
                menuItems.push({
                    label: 'Lock',
                    handler: surfaceArea.lockSelectedBoxes
                });
            }

            if( surfaceArea.isUnlockActionAvailable() )
            {
                menuItems.push({
                    label: 'Unlock',
                    handler: surfaceArea.unlockSelectedBoxes
                });
            }

            if( surfaceArea.isLockNestedActionAvailable() )
            {
                menuItems.push({
                    label: 'Lock Nested',
                    handler: surfaceArea.lockNestedInSelectedBoxes
                });
            }

            if( surfaceArea.isUnlockNestedActionAvailable() )
            {
                menuItems.push({
                    label: 'Unlock Nested',
                    handler: surfaceArea.unlockNestedInSelectedBoxes
                });
            }
        }

        if( surfaceArea.isGroupActionAvailable() || surfaceArea.isUngroupActionAvailable() )
        {
            menuItems.push({
                label: '',
                isSeparator: true
            });

            if( surfaceArea.isGroupActionAvailable() )
            {
                menuItems.push({
                    label: 'Group',
                    handler: surfaceArea.groupSelectedBoxesIntoBox
                });
            }

            if( surfaceArea.isUngroupActionAvailable() )
            {
                menuItems.push({
                    label: 'Ungroup',
                    handler: surfaceArea.ungroupSelectedBox
                });
            }
        }

        return menuItems;
    }
}
